module.exports = __webpack_public_path__ + "img/fly_cemair_logo.f07bd4d4.svg";